export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
            <path
                d="M16.8793 9.89048L11.0649 15.7049C10.646 16.1237 9.96694 16.1237 9.54809 15.7049L2.46967 8.62647C0.65464 6.81144 0.65464 3.86869 2.46967 2.05366C4.28471 0.238625 7.22746 0.238625 9.04249 2.05366L10.3005 3.31164"
                stroke="url(#paint0_linear_567_3096)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.1535 2.14171C19.9201 3.90833 19.9486 6.75487 18.239 8.55632L18.1183 8.67892L16.879 9.89178L13.9708 6.98357C13.8316 6.84435 13.606 6.84389 13.4662 6.98256L12.1263 8.31178C11.2456 9.18541 9.82436 9.18257 8.94721 8.30542L8.82717 8.18538C7.91399 7.2722 7.89275 5.80482 8.76346 4.86586L8.84074 4.78625L11.5546 2.11538C13.3883 0.310698 16.3343 0.322454 18.1535 2.14171Z"
                stroke="url(#paint1_linear_567_3096)"
            />
            <path
                d="M7.04512 3.59493C6.20742 2.75722 4.84922 2.75722 4.01152 3.59493C3.17381 4.43264 3.17381 5.79083 4.01152 6.62854"
                stroke="url(#paint2_linear_567_3096)"
                strokeLinecap="round"
            />
            <defs>
                <linearGradient id="paint0_linear_567_3096" x1="8.99385" y1="0.692383" x2="8.99385" y2="16.019" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DBAC6A" />
                    <stop offset="1" stopColor="#E5BB78" />
                </linearGradient>
                <linearGradient id="paint1_linear_567_3096" x1="16.5002" y1="0.185547" x2="10.0002" y2="8.68555" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DDAF6D" />
                    <stop offset="0.921033" stopColor="#E4B977" />
                </linearGradient>
                <linearGradient id="paint2_linear_567_3096" x1="6.28672" y1="2.83653" x2="8.50012" y2="6.18555" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#DCAE6C" />
                    <stop offset="1" stopColor="#E2B673" />
                </linearGradient>
            </defs>
        </svg>
    );
}
